import { get } from 'lodash/object'
import { find } from 'lodash/collection'
import authUser from '~/modules/auth/authUser'
import auth from '~/modules/auth/auth'
import { API_VERSIONS } from '~/modules/auth/utils/user'

export default async function ({ route, store, app }) {
  const excludedRoutes = [
    'index',
    'auth',
    'open-id',
    'show-id',
    'bulk-signature-id',
    'widget-id',
    'templates-id',
    'open-main'
  ]
  if (route && excludedRoutes.includes(route.name)) {
    return
  }
  if (app.router.currentRoute.query?.token && route.name === 'documents-id') {
    return
  }
  const user = authUser.get()
  if (auth.isAuthenticated() && !get(user, 'isSuperAdmin')) {
    const hasOrganization = store.state.organizations.items?.length
    const hasCurrentOrganization = store.state.organizations.currentOrganization
    if (!hasCurrentOrganization) {
      if (!hasOrganization) {
        await store.dispatch('organizations/getAll', { page: 1 })
      }
      const savedOrganizationId = user?.currentOrganizationId
      if (savedOrganizationId) {
        let savedOrganization = find(
          store.state.organizations.items,
          org => org.id === savedOrganizationId
        )
        if (!savedOrganization) {
          savedOrganization = await store.dispatch('organizations/read', savedOrganizationId)
        }
        store.commit('organizations/SET_CURRENT_ORGANIZATION', savedOrganization)
      }
    }
  }

  // setup up users for new documents api
  const v2Documents = [
    'inna.zhyher@checkbox.ua',
    'snizhana.lazareva@checkbox.ua',
    'alvina.romanenko@checkbox.ua',
    'daria.hilinskaja@checkbox.ua',
    'natalia.sidorenko@checkbox.ua',
    'kseniia.serhiienko@checkbox.ua',
    'mariia.lytvyn@checkbox.ua',
    'olena.tarusina@checkbox.ua'
  ]
  if (user && v2Documents.includes(user.email)) {
    const clientData = JSON.parse(localStorage.getItem('clientData')) || {}
    localStorage.setItem(
      'clientData',
      JSON.stringify({
        ...clientData,
        documentsApiVersion: API_VERSIONS.V2
      })
    )
  }
}
